import { FormEvent, useState } from "react";

interface LoginScreenProps {
  onLogin: (email: string, password: string) => Promise<void>;
  onInviteCode: (code: string) => void;
  isLoading: boolean;
  error: string | null;
}

export function LoginScreen({ onLogin, onInviteCode, isLoading, error }: LoginScreenProps) {
  const [email, setEmail] = useState("admin@dotehermes.com");
  const [password, setPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    await onLogin(email.trim(), password);
  }

  return (
    <main className="login-screen">
      <section className="login-card">
        <div className="brand-mark">车</div>
        <p className="eyebrow">dote hermes</p>
        <h1>车大师</h1>
        <p className="muted">一个私人的汽车分析、改装推演和方案工作台。</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <label>
            邮箱
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
          <label>
            密码
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              minLength={8}
            />
          </label>
          {error ? <p className="form-error">{error}</p> : null}
          <button className="primary-button" type="submit" disabled={isLoading}>
            {isLoading ? "登录中..." : "登录"}
          </button>
        </form>
        <div className="invite-code-box">
          <p className="muted">收到邀请但没有链接？输入邀请码继续注册。</p>
          <div className="invite-code-row">
            <input
              value={inviteCode}
              onChange={(event) => setInviteCode(event.target.value)}
              placeholder="邀请码"
            />
            <button
              className="secondary-button"
              type="button"
              onClick={() => onInviteCode(inviteCode.trim())}
              disabled={!inviteCode.trim()}
            >
              注册
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}
